import { Grid, useRadioGroup } from "@mui/material";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import apiClient from "lib/api-client";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const cardData = [
  {
    name: "Active Catalog",
    count: 4,
    designCount: 22,
    bg: "linear-gradient(180deg, #5BE272 0%, #327C3E 97.9%)",
    icon: "By Catalog",
  },
  {
    name: "Expired Catalog",
    count: 8,
    designCount: 63,
    bg: "linear-gradient(180deg, #E25B5B 0%, #7C3232 97.9%)",
    icon: "By Catalog",
  },
];

const buildCatalogCardData = (data = {}) => {
  const config = {
    "Active Catalogs": {
      name: "Active Catalog",
      bg: "linear-gradient(180deg, #5BE272 0%, #327C3E 97.9%)",
    },
    "Expiry Catalogs": {
      name: "Expired Catalog",
      bg: "linear-gradient(180deg, #E25B5B 0%, #7C3232 97.9%)",
    },
  };

  return Object.keys(config).map((key) => ({
    name: config[key].name,
    count: data?.[key]?.catalogCount ?? 0,
    designCount: data?.[key]?.numberOfStyles ?? 0,
    bg: config[key].bg,
    icon: "By Catalog",
  }));
};

const ClientsCatalog = () => {
  let [catalogData, setCatalogData] = useState([]);

  const { clientId } = useParams();

  useEffect(() => {
    const fetchCatalogData = async () => {
      let data = await apiClient.get(`/api/v9/myBinnys/getClientActiveExpiryCatalogData/${clientId}`);
      setCatalogData(buildCatalogCardData(data.data.data));
    };

    fetchCatalogData();
  }, []);

  if (!catalogData.length) {
    return <LoadingSmallCard count={2} />;
  }

  return (
    <div style={{ color: "yellow" }}>
      <Grid container spacing={2} marginTop={3} marginLeft={1} sx={{ display: "flex", gap: "2rem" }}>
        {catalogData?.length &&
          catalogData?.map((data) => {
            return (
              <Grid item sx={{ padding: "0px !important" }} key={data.name}>
                <ClientCard data={data} showLine={false} isCatalog={true} />
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default ClientsCatalog;
